import React from 'react'
import DataInputContainer from '../containers/DataInput'

const DataInput = () => {
  return (
    <DataInputContainer/>
  )
}

export default DataInput